var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 10.0833V5.12496C10.6666 5.0344 10.6455 4.94508 10.605 4.86408C10.5645 4.78309 10.5057 4.71263 10.4333 4.65829L6.34992 1.59579C6.24895 1.52006 6.12613 1.47913 5.99992 1.47913C5.8737 1.47913 5.75089 1.52006 5.64992 1.59579L1.56659 4.65829C1.49414 4.71263 1.43534 4.78309 1.39484 4.86408C1.35434 4.94508 1.33325 5.0344 1.33325 5.12496V10.0833C1.33325 10.238 1.39471 10.3864 1.50411 10.4958C1.6135 10.6052 1.76188 10.6666 1.91659 10.6666H4.24992C4.40463 10.6666 4.553 10.6052 4.6624 10.4958C4.77179 10.3864 4.83325 10.238 4.83325 10.0833V8.33329C4.83325 8.17858 4.89471 8.03021 5.00411 7.92081C5.1135 7.81142 5.26188 7.74996 5.41659 7.74996H6.58325C6.73796 7.74996 6.88633 7.81142 6.99573 7.92081C7.10513 8.03021 7.16659 8.17858 7.16659 8.33329V10.0833C7.16659 10.238 7.22804 10.3864 7.33744 10.4958C7.44684 10.6052 7.59521 10.6666 7.74992 10.6666H10.0833C10.238 10.6666 10.3863 10.6052 10.4957 10.4958C10.6051 10.3864 10.6666 10.238 10.6666 10.0833Z",
    stroke: "#2C358A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8d4cb8d5db42997827e73900c99db96c.svg";
export { ForwardRef as ReactComponent };